<template>
    <div class="account">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>管理员列表</el-breadcrumb-item>
        </el-breadcrumb>

        <div style="margin-top: 1rem; padding: 1.5rem 1rem 0 1rem; background-color: white">
            <el-form :inline="true" :model="query">
                <el-form-item label="账号名">
                    <el-input v-model="query.user" placeholder="账号名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onQuery">查询</el-button>
                    <el-button type="default" @click="query = {}">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 1rem; padding: 1rem; background-color: white">

            <el-button type="primary" style="margin-bottom: 1rem" @click="$router.push('/account/create')" size="small">创建账号</el-button>
            <el-table
                    :data="accounts"
                    style="width: 100%">
                <el-table-column
                        sortable
                        :sort-method="sortUserName"
                        prop="username"
                        label="账户名"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="type"
                        label="账号类型"
                >
                    <template slot-scope="scope">
                        {{scope.row.type == 1 ? "操作员" : scope.row.type == 2 ? "业务员" : "管理员"}}
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="creator"
                        label="创建人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="createTime"
                        label="创建时间"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updator"
                        label="更新人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updateTime"
                        label="更新时间"
                >
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="$router.push('/account/edit?id=' + scope.row.id)" type="text" size="small">编辑</el-button>
                        <!--                        <el-button @click="$router.push('/user/address?id=' + scope.row.id)" type="text" size="small">配送地址</el-button>-->
                        <el-button @click="deleteDevice(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    import accountApi from "../../api/account";
    export default {
        data: function () {
            return {
                accounts: [],
                page: sessionStorage.getItem("page") || 1,
                pageSize: 20,
                query: {}
            }
        },
        mounted() {
            this.loadAccounts();
        },
        methods: {
            loadAccounts: function () {
                accountApi.getAll(this.query, this.page, this.pageSize).then(accounts => {
                    this.accounts = accounts;
                })
            },
            onQuery: function () {
                this.page = 1;
                this.loadAccounts();
            },
            deleteDevice: function(id) {
                this.$confirm('确定删除该账户？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    accountApi.deleteById(id).then(result => {
                        this.loading = false;
                        this.loadAccounts();
                    })
                });
            },
            sortUserName: function (a, b) {
                return a.username.localeCompare(b.username, "zh");
            }
        }
    }
</script>
